export default {
 pageTitle: 'HK Company Registration',
 heroDesc: 'Fast, convenient, and professional HK company registration service to help your business go global',
 advantagesTitle: 'Advantages of HK Companies',
 advantagesSubtitle: 'Why register a company in HK?',
 advantage1Title: 'Low Tax Rate',
 advantage1Desc: 'HK adopts a territorial source principle for taxation, with a corporate tax rate of only 16.5% and no VAT or business tax',
 advantage2Title: 'Robust Legal System',
 advantage2Desc: 'HK has a well-established legal system and intellectual property protection regime, providing reliable protection for businesses',
 advantage3Title: 'High International Recognition',
 advantage3Desc: 'HK companies enjoy a good international reputation, facilitating international trade and investment',
 advantage4Title: 'Quick Registration',
 advantage4Desc: 'Registration can be completed in as little as 1 working day, with a simple and efficient process',
 processTitle: 'Registration Process',
 processSubtitle: 'Four simple steps to register your HK company',
 process1Title: 'Company Name Approval',
 process1Desc: 'Confirm the availability of the company name',
 process2Title: 'Prepare Documents',
 process2Desc: 'Submit documents such as shareholder and director identification',
 process3Title: 'Submit Application',
 process3Desc: 'Submit the application to the HK Companies Registry',
 process4Title: 'Receive Certificates',
 process4Desc: 'Obtain the company registration certificate and business registration certificate',
 solutionsTitle: 'Solutions',
 solutionsSubtitle: 'What problems do HK companies solve for you?',
 solution1Title: 'Expand International Markets',
 solution1Desc: 'Utilize HK\'s advantage as an international financial center to facilitate global business operations',
 solution2Title: 'Optimize Tax Structure',
 solution2Desc: 'Leverage HK\'s low tax rate policy to reduce corporate tax burden',
 solution3Title: 'Convenient Foreign Exchange Management',
 solution3Desc: 'HK has no foreign exchange controls, allowing free movement of funds',
 solution4Title: 'Enhance Corporate Image',
 solution4Desc: 'HK companies have high international recognition, boosting business credibility',
 solution5Title: 'Protect Personal Privacy',
 solution5Desc: 'Shareholder and director information can be kept confidential',
 solution6Title: 'Comprehensive Legal Protection',
 solution6Desc: 'A robust legal system protects corporate rights',
 ctaTitle: 'Ready to register your HK company?',
 ctaDesc: 'Contact us now, our professional advisors will provide you with one-on-one consulting services',
 ctaButton: 'Consult Now',
}
